import React from 'react';
import { styled } from '@linaria/react';
import { Box } from '@daedalus/atlas/helpers/Box';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const _exp = /*#__PURE__*/() => SkeletonLoader;
const ReviewScoreLoader = /*#__PURE__*/styled(_exp())({
  name: "ReviewScoreLoader",
  class: "rjvdyjp",
  propsAsIs: true
});
export const ReviewLoading = () => {
  return <Box display="flex" flexDirection="column" gap="s300">
      <Box display="flex" alignItems="center" gap="s300">
        <ReviewScoreLoader width={32} height={32} />
        <Box display="flex" flexDirection="column" gap="s100">
          <SkeletonLoader width={89} height={18} marginTop={0} />
          <SkeletonLoader width={183} height={16} marginTop={0} />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gap="s200">
        <SkeletonLoader width={298} height={24} marginTop={0} />
        <SkeletonLoader width={488} height={24} marginTop={0} />
        <SkeletonLoader width={248} height={24} marginTop={0} />
      </Box>
      <SkeletonLoader width={60} height={19} marginTop={0} />
    </Box>;
};

require("./ReviewLoading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewLoading.tsx");